import { createContext, useContext } from 'react';
export var DashboardIdContext = /*#__PURE__*/createContext(null);
DashboardIdContext.displayName = 'DashboardIdContext';
export function useDashboardId() {
  var dashboardId = useContext(DashboardIdContext);
  if (dashboardId == null) {
    throw new Error('useDashboardId must be used within a DashboardIdContext provider');
  }
  return dashboardId;
}
//# sourceMappingURL=useDashboardId.js.map